import { styled, css } from "@sourceful/shared-components";
import toRem from "@styles/postprocess/conversion/to-rem";
import Link from "next/link";

export const Logo = styled("a", {
  display: "flex",
  alignItems: "center",
  color: "#404044",
  width: toRem(96),
  position: "relative",
  transition: "all 0.2s",

  "&:hover": {
    opacity: 0.7,
  },

  "@md": {
    width: toRem(135),
  },
});

export const logoSvgCss = css({
  position: "relative",
  top: "-2px",
});

interface SiteLogoProps {
  ariaLabel?: string;
  href?: string;
}

const SiteLogo = ({ ariaLabel, href }: SiteLogoProps) => {
  const LogoIcon = (
    <Logo aria-label={ariaLabel}>
      <svg
        className={logoSvgCss()}
        xmlns="http://www.w3.org/2000/svg"
        width="150"
        height="50"
        viewBox="50 0 440 163.931"
      >
        <path
          d="M474.937,45.062v71.984h-12v-72Zm-385,41.025h-25a2.652,2.652,0,0,1-3-3v-2a2.652,2.652,0,0,1,3-3h26l.039-12h-20.3a4.281,4.281,0,0,0-2.736.988L51.484,80.444a4.285,4.285,0,0,0-1.547,3.3v8.331a3.829,3.829,0,0,0,4,4.016h26a2.652,2.652,0,0,1,3,3v3c0,2-1.019,2.953-3,3l-30,.046v11.954H73.9a4.287,4.287,0,0,0,2.653-.921l16.388-13.079a4.825,4.825,0,0,0,2-4v-8A4.724,4.724,0,0,0,89.937,86.087Zm64.945,5.872c0,16.152-11.8,27.128-26.921,27.128s-26.92-10.976-26.92-27.128,11.8-27.127,26.92-27.127S154.882,75.808,154.882,91.959Zm-13.046,0c0-9.318-5.616-15.872-13.9-15.872s-13.85,6.554-13.85,15.872,5.567,16.128,13.85,16.128S141.836,101.278,141.836,91.959ZM282.86,107.484c-8.391,0-13.879-6.214-13.879-15.529s6-15.53,13.879-15.53c6.453,0,10.33,3.49,12.03,8.172L306.2,78.016c-4.1-8.063-12.1-13.183-23.553-13.183-14.913,0-26.714,11.174-26.714,27.122s11.8,27.132,26.714,27.132c11.2,0,19.149-4.832,23.285-12.5l-11.374-6.561C292.693,104.6,289.114,107.484,282.86,107.484Zm79.323-16.393v4h-38c.518,6.834,5.494,12.814,12.949,12.814,7.248,0,11.079-4.038,12.839-7.662l10.665,6.212c-3.521,5.384-9.526,12.632-23.3,12.632-15.324,0-26.4-11.6-26.4-27.542,0-15.531,10.664-26.713,25.781-26.713C351.628,64.832,362.183,75.663,362.183,91.091Zm-13.765-4.412c-.932-6.523-5.073-10.665-11.8-10.665-7.352,0-11.183,4.349-12.219,10.665Zm36.75-42.6-13.683,11.36a4.283,4.283,0,0,0-1.548,3.3v58.315h13v-37a3.815,3.815,0,0,1,4-4h9v-10h-9a3.816,3.816,0,0,1-4-4v-3a3.826,3.826,0,0,1,4-4h12V43.087H387.9A4.285,4.285,0,0,0,385.168,44.074ZM197.937,92.593c0,9.111-4.231,14.494-12,14.494h-7a3.816,3.816,0,0,1-4-4v-37h-13v36.156a4.286,4.286,0,0,0,1.548,3.3l13.759,11.56a4.281,4.281,0,0,0,2.735.987h1.958c9.422,0,13.929-4.238,16-9h1v8h12l.047-51H197.937Zm37.7-25.519L221.485,78.817a4.283,4.283,0,0,0-1.548,3.3v34.973h13v-35a3.815,3.815,0,0,1,4-4h15v-12H238.375A4.283,4.283,0,0,0,235.64,67.074Zm204.3,25.478c0,9.111-4.231,14.494-12,14.494h-7a3.815,3.815,0,0,1-4-4v-37h-13V102.2a4.286,4.286,0,0,0,1.548,3.3l13.759,11.56a4.281,4.281,0,0,0,2.735.987h1.958c9.422,0,13.929-4.238,16-9h1v8h12l.047-51H439.937Z"
          fill="currentColor"
        ></path>
      </svg>
    </Logo>
  );

  if (href) {
    return (
      <Link passHref href={href} legacyBehavior>
        {LogoIcon}
      </Link>
    );
  }

  return LogoIcon;
};

export default SiteLogo;
